import { useCallback, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Spin } from "antd";
import {
	SubmitButtonOverlay,
	ActionContainer,
	ActionItemsContainer,
	FormHeaderComponent,
} from "../../components/styled/common";
import BackComponent from "../../components/BackComponent";
import MainButtonComponent from "../../components/MainButtonComponent";
import VolunteersFAQForm, {
	applyFAQLocalizableChanges,
	VolunteersFAQGeneralValues,
	VolunteersFAQLocalizableChanges,
} from "../../components/VolunteersFAQForm";
import { useVolunteersFAQContext } from "../../context/VolunteersFAQContext/VolunteersFAQContext";
import { VOLUNTEERS_FAQ_LIST_PATH } from "../../context/VolunteersFAQContext/constants";
import { Culture } from "../../context/VolunteersHighlightContext/constants";

const EditVolunteersFAQ = () => {
	const { id } = useParams<{ id: string }>();
	const {
		updateVolunteersFAQ,
		getVolunteersFAQDetails,
		clearVolunteersFAQFormData,
		volunteersFAQEditForm,
		setVolunteersFAQEditForm,
		operationStatus,
	} = useVolunteersFAQContext();

	const isFetching = operationStatus.type === "loading" && operationStatus.operation === "fetch";

	useEffect(() => {
		if (id) {
			getVolunteersFAQDetails(id);
		}

		return () => {
			clearVolunteersFAQFormData();
		};
	}, [id, getVolunteersFAQDetails, clearVolunteersFAQFormData]);

	const handleGeneralChange = useCallback((changes: Partial<VolunteersFAQGeneralValues>) => {
		setVolunteersFAQEditForm(prev => (prev ? { ...prev, ...changes } : null));
	}, [setVolunteersFAQEditForm]);

	const handleLocalizableChange = useCallback((culture: Culture, changes: VolunteersFAQLocalizableChanges) => {
		setVolunteersFAQEditForm(prev => (prev ? {
			...prev,
			volunteersFAQLocalizable: applyFAQLocalizableChanges(prev.volunteersFAQLocalizable, culture, changes),
		} : null));
	}, [setVolunteersFAQEditForm]);

	return (
		<>
			<BackComponent text="Merak Edilenler Listesine Dön" to={VOLUNTEERS_FAQ_LIST_PATH} />
			<ActionContainer>
				<Spin spinning={isFetching}>
					<ActionItemsContainer>
						<FormHeaderComponent>Merak Edilen Güncelleme</FormHeaderComponent>
						{volunteersFAQEditForm && (
							<VolunteersFAQForm
								key={volunteersFAQEditForm.faqId}
								general={volunteersFAQEditForm}
								localizables={volunteersFAQEditForm.volunteersFAQLocalizable}
								isRequired={false}
								onGeneralChange={handleGeneralChange}
								onLocalizableChange={handleLocalizableChange}
							/>
						)}
						<SubmitButtonOverlay>
							<MainButtonComponent
								onClick={updateVolunteersFAQ}
								type="default"
								disabled={!volunteersFAQEditForm}
								loading={operationStatus.type === "loading" && operationStatus.operation === "update"}
							>
								Güncelle
							</MainButtonComponent>
						</SubmitButtonOverlay>
					</ActionItemsContainer>
				</Spin>
			</ActionContainer>
		</>
	);
};

export default EditVolunteersFAQ;
